<script lang="ts" setup>
import { CircleCheck, CircleFadingArrowUp, CircleX, File, FileImage, FilePlay, Loader } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

defineProps({
  name: {
    type: String,
    required: true,
  },

  progress: {
    type: Number,
    default: 0,
  },

  type: {
    type: String,
    required: false,
    default: 'default',
  },
});

const { t } = useI18n();
const emit = defineEmits<{ (e: 'remove'): void }>();

function remove(): void {
  emit('remove');
}
</script>

<template>
  <div class="relative overflow-hidden rounded-lg bg-slate-100 p-3">
    <div class="flex items-center gap-2">
      <FilePlay
        v-if="type.includes('video/')"
        class="size- stroke-[1.5]"
      />
      <FileImage
        v-else-if="type.includes('image/')"
        class="size-6 stroke-[1.5]"
      />
      <File
        v-else
        class="size-6 stroke-[1.5]"
      />
      <span class="text-md ">
        {{ name }}
      </span>
    </div>
    <div
      v-if="progress >= 1"
      class="flex items-center gap-2 pl-8 text-green-800"
    >
      <CircleCheck class="size-4" />
      <span class="text-sm ">
        {{ t('customer.global:file-upload:uploading-successful') }}
      </span>
    </div>

    <div
      v-if="progress > 0 && progress < 1"
      class="flex items-center gap-2 pl-8 text-brand-500"
    >
      <Loader class="size-4 animate-spin" />
      <span class="text-sm ">
        {{ t('customer.global:file-upload:uploading') }}
      </span>
      <div
        class="absolute bottom-0 left-0 h-1 bg-brand-500"
        :style="{ width: `${progress * 100}%` }"
      />
    </div>

    <div
      v-if="progress === 0 || progress === null"
      class="flex items-center gap-2 pl-8 text-slate-500"
    >
      <CircleFadingArrowUp class="size-4" />
      <span class="text-sm ">
        {{ t('customer.global:file-upload:uploading-waiting') }}
      </span>
    </div>

    <div class="absolute right-3 top-3">
      <CircleX
        class="h-5 w-5 cursor-pointer text-slate-400 hover:text-slate-500"
        @click="remove"
      />
    </div>
  </div>
</template>
